
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { getServerSession } from 'modules/auth/server';
import AmbassadorsPage from 'modules/Marketing/pages/Ambassadors';
import UserModel from 'modules/User/models/User';
import type { GetServerSideProps } from 'next';
import dbConnect from 'utils/db';
const getServerSideProps: GetServerSideProps = async (context) => {
    await dbConnect();
    const session = await getServerSession(context);
    if (context.locale === 'en') {
        return {
            redirect: {
                destination: '/fr/ambassadors',
                permanent: false,
            },
        };
    }
    const ambassadors = await UserModel.find({ ambassadorFor: { $exists: true } })
        .select('_id name firstName lastName image ambassadorFor phone url')
        .sort({ ambassadorFor: 1 })
        .lean({ virtuals: true });
    return {
        props: {
            session: JSON.parse(JSON.stringify(session)),
            ambassadors: JSON.parse(JSON.stringify(ambassadors)),
        },
    };
};
export default AmbassadorsPage;

    async function __Next_Translate__getServerSideProps__197dae1f0d9__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/ambassadors',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__197dae1f0d9__ as getServerSideProps }
  